<template>
    <div class="page-auth">
        <div class="login-page">
            <div class="hidden bg-transparent lg:flex flex-col items-center justify-center">
                <p class="text-white text-4xl text-center w-5/6">{{displayedText}} <span class="cursor" v-if="showCursor">|</span></p>
            </div>
            <div class="content-form flex flex-col items-center justify-center bg-transparent h-full">
                <div class="mx-auto grid w-4/5 md:w-3/4 gap-6 bg-white py-8 px-3 rounded-15">
                    <div class="grid gap-2 text-center justify-items-center items-center ">
                        <div class="w-3/4 mb-3 flex justify-center">
                            <img class="logo-img" :src="logoUrl"
                            alt="cyberforceacademy logo" v-if="isLogoUrl"  >
                            <img class="" src="../../assets/auth/images/spec-brand-1.svg"
                            alt="cyberforceacademy logo" v-else  >
                        </div>
                        
                        <!-- Google Email Form -->
                        <form class="grid gap-3 px-4" @submit.prevent="handleSubmit">
                            <div class="text-center mb-4">
                                <h2 class="text-2xl font-medium text-gray-800 mb-2">Connexion avec Google</h2>
                                <p class="text-gray-600">Entrez votre adresse email pour continuer avec Google</p>
                            </div>
                            
                            <div>
                                <label class="block font-medium text-left text-gray-700 mb-1">Email</label>
                                <input
                                type="email"
                                v-model="formData.email"
                                class="w-full px-4 py-2 input input-bordered ui-input"
                                :class="{ 'ui-input--error': errors.email }"
                                placeholder="Entrez votre adresse email"
                                />
                                <p v-if="errors.email" class="text-red-500 text-sm mt-1 text-left">{{ errors.email }}</p>
                            </div>

                            <button
                                type="submit"
                                class="w-full flex items-center justify-center gap-3 bg-spect text-white py-3 rounded-6 hover:bg-opacity-90 transition-colors btn-disable" :disabled="isInvalid || isSubmit"
                            >
                                <span v-if="isSubmit" class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></span>
                                <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M9 12l2 2 4-4"/>
                                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                                    <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                                    <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                                    <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                                </svg>
                                <span>
                                    Continuer avec SSO
                                </span>
                            </button>
                            
                            <div class="text-center mt-4">
                                <a href="/login" class="text-accent text-sm">
                                    ← Retour à la connexion
                                </a>
                            </div>
                            
                            <div class="flex items-center justify-center">
                                <span class="ml-2 text-sm text-gray-600">
                                    En continuant, vous acceptez les termes de notre <a href="https://cyberspector.com/politique-de-confidentialite-et-de-protection-des-donnees/" target="_blank" class="text-accent">politique de confidentialité</a>
                                    et nos réglementations concernant les <a href="https://cyberspector.com/politique-de-confidentialite-et-de-protection-des-donnees/" target="_blank" class="text-accent">cookies</a> 
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="toast toast-end my-toast fixed -right-10 bottom-0" v-if="isAlert">
            <div class="alert alert-info toast-ctn--info">
                <span>{{ alertMessage }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'GoogleEmailPage',
    data() {
        return {
            formData: {
                email: '',
            },
            errors: {
                email: null,
            },
            isSubmit: false,
            isInvalid: false,
            isAlert: false,
            alertMessage: "New message",
            txt: 'Placez l\'humain au coeur de votre Stratégie de Cyberdéfense', // Text to display
            displayedText: '', // Currently displayed text
            speed: 100, // Typing speed in milliseconds
            backspaceSpeed: 50, // Backspace speed
            i: 0, // Character index
            showCursor: true, // Cursor blinking
            isDeleting: false, // Backspace mode flag
        }
    },
    computed: {
        isLogoUrl : {
            get () {
                const logo = localStorage.getItem("domainLogo");
                return logo && logo !== "null" && logo !== "undefined" && logo.trim() !== "";
            },
            set (value) {
                console.log(value)
            }
        },
        logoUrl () {
            const logo = localStorage.getItem("domainLogo");
            if (logo && logo !== "null" && logo !== "undefined" && logo.trim() !== "") {
                return logo;
            }
            return "../../assets/auth/images/spec-brand-1.svg"
        }
    },
    methods : {
        validateEmail() {
            this.errors.email = null
            let isValid = true

            if (!this.formData.email || this.formData.email.trim() == "") {
                this.errors.email = 'Le champ email est obligatoire.'
                isValid = false
            } else if (!this.isValidEmail(this.formData.email)) {
                this.errors.email = 'Veuillez entrer une adresse email valide.'
                isValid = false
            }
            return isValid
        },
        
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return emailRegex.test(email)
        },
        
        async handleSubmit () {
            if (this.validateEmail()) {
                console.log("SSO email submission:", this.formData.email);
                this.isSubmit = true;
                
                try {
                    // Call the SSO initiate API
                    const response = await axios.post(`${process.env.VUE_APP_BASE_URL}sso/sso-initiate/`, {
                        email: this.formData.email
                    });
                    
                    console.log('SSO initiate response:', response);
                    
                    if (response.status === 200) {
                        // Check if response contains redirect URL
                        if (response.data && response.data.redirect_url) {
                            // Redirect to SSO provider URL
                            window.location.href = response.data.redirect_url;
                        } else if (response.data && response.data.auth_url) {
                            // Alternative field name for auth URL
                            window.location.href = response.data.auth_url;
                        } else if (response.data && response.data.activation_required) {
                            // If activation is required, redirect to activation page
                            this.$router.push(`/sso/account?email=${encodeURIComponent(this.formData.email)}`);
                        } else {
                            // If no redirect URL, show success message
                            this.showAlert('Connexion SSO initiée avec succès. Vérifiez votre email pour continuer.');
                        }
                    } else {
                        this.showAlert('Une erreur s\'est produite lors de l\'initiation de la connexion SSO.');
                    }
                    
                } catch (error) {
                    console.error('SSO initiate error:', error);
                    
                    if (error.response) {
                        // Server responded with error status
                        const errorMessage = error.response.data?.message || error.response.data?.error || 'Une erreur serveur s\'est produite.';
                        this.showAlert(`Erreur: ${errorMessage}`);
                    } else if (error.request) {
                        // Network error
                        this.showAlert('Erreur de connexion. Vérifiez votre connexion internet et réessayez.');
                    } else {
                        // Other error
                        this.showAlert('Une erreur inattendue s\'est produite. Veuillez réessayer.');
                    }
                } finally {
                    this.isSubmit = false;
                }
            }
        },
        
        // Show alert message
        showAlert(message) {
            this.alertMessage = message;
            this.isAlert = true;
            
            setTimeout(() => {
                this.isAlert = false;
            }, 5000);
        },

        startTyping() {
            if (!this.isDeleting && this.i < this.txt.length) {
                // Forward typing
                this.displayedText += this.txt.charAt(this.i);
                this.i++;
                setTimeout(this.startTyping, this.speed);
            } else if (this.isDeleting && this.i > 0) {
                // Backspacing
                this.displayedText = this.displayedText.slice(0, -1);
                this.i--;
                setTimeout(this.startTyping, this.backspaceSpeed);
            } else {
                // Toggle between typing and backspacing
                this.isDeleting = !this.isDeleting;
                setTimeout(this.startTyping, 1000); // Pause before changing direction
            }
        },
    },
    mounted() {
        this.startTyping();
        setInterval(() => {
            this.showCursor = !this.showCursor; // Blinking cursor effect
        }, 500);
    },
    async beforeRouteEnter () {
        try {
            const rootUrl = window.location.host;
            console.log(rootUrl);
            const response = await axios.post(`${process.env.VUE_APP_BASE_URL}organisations/organisation_details`, {
                url_access : rootUrl
            });
            console.log(response)
            if (response.status === 200) {
                const data = response.data;
                // Only store the logo if it's not null, undefined, or empty
                if (data.logo && data.logo !== "null" && data.logo !== "undefined") {
                    localStorage.setItem("domainLogo", data.logo);
                } else {
                    // Remove the item if it's null to ensure fallback to default logo
                    localStorage.removeItem("domainLogo");
                }
            }
        } catch (error) {
            if (error.response) {
                const errorMessage = error.response.data.Message;
                if (errorMessage === 'Invalid Credentials') {
                    // Handle error
                } else if (errorMessage === 'Your account has been blocked. Please check your email for verification code.') {
                    // Handle error
                } else {
                    // Handle error
                }
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    @use "../../assets/scss/tailwinds.scss";
    .cursor {
        display: inline-block;
        width: 10px;
        height: 20px;
        background-color: red;
        animation: blink 1s step-start infinite;
    }

    @keyframes blink {
    50% {
        opacity: 0;
    }
    }
</style>
